export default __webpack_public_path__ + "static/media/office1-before2-2048w.3112d796.webp";